module.exports = __webpack_public_path__ + "static/media/New Project(1).5ef90d67.png";